module.exports = __webpack_public_path__ + "static/media/living_room_square.464c1269.png";